import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { CopyOrderDetails, QueryTranslationRequestCopyOrderDetailsArgs } from 'gql/graphql';
import { gql } from 'graphql-request';
import { TGenericError } from 'types/TGenericError';
import clientUtil from 'utils/clientUtil';

type TData = CopyOrderDetails;
type TVariables = QueryTranslationRequestCopyOrderDetailsArgs;

const MOCK: TVariables = { guid: '' };

export const useTranslationRequestCopyOrderDetailsResult = (
  variables: TVariables = MOCK,
  options: Omit<UseQueryOptions<unknown, TGenericError, TData>, 'queryKey'> = {}
) => {
  const client = clientUtil();

  const graphql = gql`
    query translationRequestCopyOrderDetails($guid: String!) {
      translationRequestCopyOrderDetails(guid: $guid) {
        orderDetails {
          details {
            cost
            currency
            languageCode
            pricePerWord
            savings
            words
            duplicateContent
          }
          detailsTotal
        }
        wordCount
      }
    }
  `;

  return useQuery<unknown, TGenericError, TData>({
    ...options,
    queryKey: ['translationRequestCopyOrderDetailsResult', variables.guid],
    queryFn: async () =>
      client.request({
        data: {
          gql: graphql,
          variables
        }
      })
  });
};
